import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import type { ReportFragmentAction } from 'webapp/enums/enums';

import type { ReportFragmentActionData } from 'webapp/components/reports/editor-base';
import ReportsSlideBottomInfoComponent from 'webapp/components/reports/slide-bottom-info';

import type ReportSlide from 'webapp/models-custom/report-slide';
import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlide;
}

interface ReportsViewerSlideWrapperComponentInterface<T> {
	Args: T;
	Blocks: {
		default: [
			onFragmentChange: (
				fragment: ReportSlideFragment,
				action: ReportFragmentAction,
				data?: ReportFragmentActionData,
			) => Promise<unknown>,
		];
	};
}

export default class ReportsViewerSlideWrapperComponent<T extends Args> extends Component<
	ReportsViewerSlideWrapperComponentInterface<T>
> {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;

	usercontentNode: HTMLElement | null = null;

	constructor(owner: Owner, args: T) {
		super(owner, args);
		void this.mmReportsService.loadFonts();
	}

	get hideBranding(): boolean {
		return this.accountService.removeBrandingOnFeatures;
	}

	@action
	onFragmentChange(
		_fragment: ReportSlideFragment,
		_action: ReportFragmentAction,
		_data?: ReportFragmentActionData,
	): Promise<unknown> {
		// nothing - this is just to satisfy TS for yield. only editor handles the method
		return Promise.resolve();
	}

	@action
	setupUsercontentNode(node: HTMLElement): void {
		this.usercontentNode = node;
	}
	<template>
		{{#if @model.isTypeBoard}}
			<div class="report_slide report_slide--board">
				{{yield this.onFragmentChange}}
			</div>
		{{else}}
			<div
				class="report_slide bgTheme-{{@model.bgTheme}} colorTheme-{{@model.themeId}}"
				style={{@model.colorStyle}}
			>
				<div class="bg" style={{@model.bgStyle}}></div>

				<div class="content-inner">

					<div class="usercontent">
						{{yield this.onFragmentChange}}
					</div>

					<ReportsSlideBottomInfoComponent
						@model={{@model}}
						@hideBranding={{this.hideBranding}}
					/>

				</div>

			</div>
		{{/if}}
	</template>
}
